import { render, staticRenderFns } from "./TrainingQuizQuestionTypeMapping.vue?vue&type=template&id=466590fc&"
import script from "./TrainingQuizQuestionTypeMapping.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestionTypeMapping.vue?vue&type=script&lang=js&"
import style0 from "./TrainingQuizQuestionTypeMapping.vue?vue&type=style&index=0&id=466590fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports